module.exports = __webpack_public_path__ + "img/pocket.c9b1c08e.png";